module.exports = require('./helpers/bundle-url').getBundleURL('1KTPu') + "logo-dark.ba5147f0.svg";